import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `Application/Beneficiaries/ImportedDocuments/**`. */
const ImportedDocumentsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="DOCUMENT_IMPORTED"
				title="Document importé"
				message="Le document est en cours de conversion."
			/>
			<SuccessNotification
				eventName="IMPORTED_DOCUMENT_RENAMED"
				title="Document renommé"
				message="Le nouveau nom a été enregistré."
			/>
			<ErrorNotification
				eventName="DOCUMENT_IMPORT_FAILED"
				title="Erreur"
				message="Le document n'a pas pu être importé."
			/>
		</React.Fragment>
	);
};

export default ImportedDocumentsNotifications;
